import React, { createContext, useContext, useState, useEffect } from 'react';

// Создаем контекст
const AuthContext = createContext();

// Хук для быстрого доступа к контексту
export const useAuth = () => useContext(AuthContext);

// Провайдер
export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);
  const [userKursData, setUserKursData] = useState(null);
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'uz';
  });

  const isAuthenticated = !!token;

  // Сохраняем userKursData в localStorage при изменении
  useEffect(() => {
    if (userKursData) {
      localStorage.setItem('userKursData', JSON.stringify(userKursData));
    }
  }, [userKursData]);

  // Восстановление состояния при загрузке
  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    const storedUser = localStorage.getItem('user');
    const storedLang = localStorage.getItem('language');
    const storedKursData = localStorage.getItem('userKursData');

    if (storedToken && storedUser) {
      const parsedUser = JSON.parse(storedUser);
      const userWithId = {
        ...parsedUser,
        id: parsedUser.id || parsedUser.pk,
      };
      delete userWithId.pk;

      setToken(storedToken);
      setUser(userWithId);
    }

    if (storedLang) {
      setLanguage(storedLang);
    }

    if (storedKursData) {
      setUserKursData(JSON.parse(storedKursData));
    }
  }, []);

  // Вход
  const login = ({ token, user }) => {
    const userWithId = user;
    // delete userWithId.pk;

    setToken(token);
    setUser(userWithId);
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userWithId));
  };

  // Выход
  const logout = () => {
    setToken(null);
    setUser(null);
    setUserKursData(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('userKursData');
    // localStorage.removeItem('language'); // если хочешь сбрасывать язык при выходе
  };

  const handleLang = (uz, ru, en) => {
    if (language === 'ru' && ru) return ru;
    if (language === 'uz' && uz) return uz;
    if (language === 'en' && en) return en;
    return uz || ru || en || '';
  };

  // При смене языка — обновим localStorage
  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  return (
    <AuthContext.Provider value={{
      token,
      user,
      isAuthenticated,
      login,
      logout,
      userKursData,
      setUserKursData,
      language,
      setLanguage,
      handleLang
    }}>
      {children}
    </AuthContext.Provider>
  );
};
